<template>
  <div class="checkbox_base">
    <div :style="{'width': `${size}px`, 'height': `${size}px` }" :class="{'checked': checked}" class="checkbox" @click="$emit('input', checked ? falseValue : trueValue)" >
      <v-icon :style="{'font-size': `${size / (20/16)}px`, 'opacity': value === trueValue ? 1 : 0}">check</v-icon>
    </div>
    <span @click="$emit('input', checked ? falseValue : trueValue)"><slot></slot></span>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Boolean],
    trueValue: {
      type: [String, Boolean],
      default: true
    },
    falseValue: {
      default: false
    },
    size: {
      type: Number,
      default: 20
    }
  },
  computed: {
    checked() {
      return this.value === this.trueValue
    }
  }
}
</script>

<style>
.checkbox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #bfc2d1;
    color: #bfc2d1;
    width: 20px;
    height: 20px;
    font-size: 14px;
    border-radius: 2px;
    transition: all 0.05s;
}
 .checkbox:hover {
    cursor: pointer;
    border-color: #d81818;
    color: #d81818;
}
 .checkbox:hover i {
    opacity: 1 !important;
}
 .checkbox.checked {
    background: #d81818;
    border-color: #d81818;
}

.checkbox.checked > * {
    color: white;
}
 .checkbox_base span:hover {
    cursor: pointer;
}
 
</style>


// WEBPACK FOOTER //
// src/components/Checkbox.vue